/* eslint-disable clubmed/use-alias */
/* eslint-disable import/no-relative-parent-imports */
import classNames from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';

import { theme } from 'Root/tailwind.config';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      colors: Object.keys(theme.colors).map((key) => key),
    },
    classGroups: {
      bgColor: Object.keys(theme.colors).map((key) => `bg-${key}`),
      fontSize: Object.keys(theme.fontSize).map((key) => `text-${key}`),
      fontFamily: Object.keys(theme.fontFamily).map((key) => `font-${key}`),
      textColor: Object.keys(theme.colors).map((key) => `text-${key}`),
    },
  },
});

export const classnames = (...inputs) => twMerge(classNames(inputs));
